import { Component, EventEmitter, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import {
  HeaderFilters,
  HttpService,
  MenuBreadCrumb,
  params,
  TableColumns,
  TableConfiguration,
} from 'brainloper-ui';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { GeneratePdfFosilService } from 'app/services/generate-pdf-fosil.service';
import { ModalHistoryComponent } from './modal-maintenance-history/modal-maintenance-history.component';
import { HistoricalWO } from 'app/models2/maintenance/historicalWO';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { CommentService } from 'app/services/comment.service';

@Component({
  selector: 'app-maintenance-history',
  templateUrl: './maintenance-history.component.html',
  styleUrls: ['./maintenance-history.component.scss'],
})
export class MaintenanceHistoryComponent implements OnInit {
  public data: HistoricalWO;
  public selected = new UntypedFormControl(0);
  public detailsClickRow: HistoricalWO;

  public urlTablaOT: string = `${EndpointDictionary.historicalWO.HISTORICAL_WO_TABLE}`;
  private urlDetalleHistorico: string = `${EndpointDictionary.historicalWO.CRUD_HISTORICAL_WO_DATA}`;
  private urlComboEquipo: string = `${EndpointDictionary.Equipment.EQUIPMENT_COMBO}`;
  private urlComboUsuarios: string = `${EndpointDictionary.User.USER_COMBO}`;

  public params: params[] = [];

  //tabla ordenes de trabajo
  public titleOT: string =
    screen.width > 360 ? 'Historial Mantenimiento' : 'H. Mtto';
  public recargarTablaOT = new EventEmitter<any>();
  public configurationOT: TableConfiguration = {
    edit: true,
    add: false,
    delete: false,
    selectable: false,
    editPer: true,
    primaryKey: 'id',
    exportXslx: true,
    hideTitle: true,
    print: true,
    view: true,
    addComment: true,
  };

  public columnasOT: TableColumns<HistoricalWO>[] = [
    {
      ID: 'consecutive',
      label: '#',
      type: 'text',
      style: {
        textAlign: 'center',
        width: '100px',
      },
    },
    {
      ID: 'code',
      label: 'Codigo',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'responsible',
      label: 'Responsable',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'odometer',
      label: 'Odómetro/Horómetro',
      type: 'number',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'description',
      label: 'Descripción',
      type: 'text',
      style: {
        textAlign: 'center',
        width: '30%',
      },
    },
    {
      ID: 'maintenanceType',
      label: 'Tipo mantenimiento',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'executionDate',
      label: 'Fecha',
      type: 'fecha',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'finalCost',
      label: 'Costo',
      type: 'number',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'invoiceReference',
      label: 'Ref. Factura',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'maintenanceProvider',
      label: 'Proveedor',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
        width: '20%',
      },
    },
  ];

  headerFilters: Array<HeaderFilters> = [
    {
      tN: 'equipos',
      labelFilter: 'Equipo',
      urlData: this.urlComboEquipo,
      visibleField: 'code',
      primaryKey: 'id',
      type: 'select',
      value: '',
    },
    {
      tN: 'ordenes_trabajo',
      labelFilter: 'Responsable',
      urlData: this.urlComboUsuarios,
      visibleField: 'name',
      primaryKey: 'userId',
      type: 'select',
      value: '',
      fileNameDb: 'responsable',
    },
    {
      tN: 'ordenes_trabajo',
      visibleField: 'fecha_ejecucion',
      labelFilter: 'Fecha Ejecución',
      type: 'date',
      value: '',
    },
    {
      tN: 'ordenes_trabajo',
      visibleField: 'fecha_ejecucion',
      labelFilter: 'Fecha Ejecución Entre',
      type: 'dateRange',
      value: '',
    },
  ];

  public menuBreadCrumb: Array<MenuBreadCrumb> = [
    {
      name: 'Inicio',
      router: '/inicio',
    },
    {
      name: 'Historial',
      current: true,
    },
  ];

  headerFileXlsm: Array<params> = [
    { id: 'consecutive', value: 'Número de Orden' },
    { id: 'code', value: 'Código del equipo' },
    { id: 'odometer', value: 'Odómetro/Horómetro' },
    { id: 'componentName', value: 'Componente' },
    { id: 'responsible', value: 'Responsable' },
    { id: 'responsibleId', value: 'Cédula' },
    { id: 'finalCost', value: 'Costo' },
    { id: 'executionDate', value: 'Fecha' },
    { id: 'maintenanceProvider', value: 'Proveedor mantenimiento' },
    { id: 'maintenanceType', value: 'tipo mantenimiento' },
    { id: 'finalTime', value: 'Tiempo' },
    { id: 'resources', value: 'Recursos' },
    { id: 'description', value: 'Descripción' },
    { id: 'observations', value: 'Observaciones' },
  ];

  constructor(
    public dialog: MatDialog,
    private http: HttpService,
    private generatePdf: GeneratePdfFosilService,
    private commentService: CommentService
  ) {}

  ngOnInit(): void {}

  async clickFilaOT($event: HistoricalWO[]) {
    this.detailsClickRow = $event[0];
    this.selected.setValue(1);
  }

  back($event: MatTabChangeEvent) {
    switch ($event.index) {
      case 0:
        this.selected.setValue(0);
        break;
      case 1:
        this.selected.setValue(1);
        break;
      case 2:
        this.selected.setValue(2);
        break;
      default:
        break;
    }

    //console.log($event)
  }

  async editOT($event: HistoricalWO[]) {
    let res: Array<HistoricalWO> = await this.http.getDataBody(
      `${this.urlDetalleHistorico}/${$event[0].id}`
    );
    if (res) {
      this.dialog
        .open(ModalHistoryComponent, {
          width: '80%',
          height: '80%',
          data: { body: res[0], $event: $event[0] },
        })
        .afterClosed()
        .subscribe((res) => {
          this.recargarTablaOT.emit();
        });
    }
  }

  async print($event: HistoricalWO[]) {
    this.generatePdf.printTemplateOt($event[0].workOrderId);
  }

  addComment($event: HistoricalWO[]) {
    this.commentService.addComment($event[0].workOrderId);
  }
}
